import { Pipe, PipeTransform } from '@angular/core';
import { App } from '@df/core/app';
import { ProcessorService } from '@df/ng/processor.service';

@Pipe({
    name: 'optionLabel',
    standalone: true
})
export class OptionLabelPipe implements PipeTransform {
    transform = optionLabelPipe;
}

export function optionLabelPipe(
    optionValue: number | string | number[] | undefined,
    attributeCode: string,
    skipMissingLabels: boolean = false
): string | number | undefined {
    if (typeof optionValue === 'undefined') {
        return undefined;
    }
    const app = ProcessorService.injector.get(App);
    const attributeModel = app.resources.attribute.getExisting(attributeCode);
    if (!attributeModel?.data?.options) {
        return <string>optionValue;
    }
    const label = attributeModel.getOptionLabel(optionValue);
    if (skipMissingLabels && label === optionValue) {
        return undefined;
    }
    return Array.isArray(label) ? label.join(', ') : label;
}
